import { BehaviorSubject } from 'rxjs';

export class NotificationDatabase {
  dataChange: BehaviorSubject<any[]>;
  get data(): any[] {
    return this.dataChange.value;
  }
  constructor() {
    this.dataChange = new BehaviorSubject<any[]>([]);
  }
  updateNotificationRecords(notificationRecords) {
    this.dataChange.next(notificationRecords);
  };
}
